var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_92_1396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 36C16.5 24.7643 16.5 19.1465 19.1965 15.1109C20.3638 13.3638 21.8638 11.8638 23.6109 10.6965C27.6465 8 33.2643 8 44.5 8C55.7357 8 61.3535 8 65.3891 10.6965C67.1362 11.8638 68.6362 13.3638 69.8035 15.1109C72.5 19.1465 72.5 24.7643 72.5 36C72.5 47.2357 72.5 52.8535 69.8035 56.8891C68.6362 58.6362 67.1362 60.1362 65.3891 61.3035C61.3535 64 55.7357 64 44.5 64C33.2643 64 27.6465 64 23.6109 61.3035C21.8638 60.1362 20.3638 58.6362 19.1965 56.8891C16.5 52.8535 16.5 47.2357 16.5 36Z",
    fill: "url(#paint0_linear_92_1396)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9983 23.2608C56.8596 22.0333 53.5314 23.9523 53.3916 24.0341C53.0937 24.2086 52.9937 24.5913 53.1676 24.8892C53.3422 25.187 53.7261 25.2865 54.0227 25.1132C54.8058 24.6542 57.1129 23.6227 58.3769 24.3447C59.0514 24.7317 59.3932 25.6332 59.3932 27.0242C59.3932 32.7023 57.8185 33.713 53.3837 33.713C53.0382 33.713 52.7587 33.9926 52.7587 34.338C52.7587 34.6835 53.0382 34.963 53.3837 34.963C58.8793 34.963 60.6432 33.0337 60.6432 27.0242C60.6432 25.1522 60.0896 23.8864 58.9983 23.2608Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6163 33.713C31.1815 33.713 29.6068 32.7023 29.6068 27.0242C29.6068 25.6338 29.9486 24.7329 30.6218 24.346C31.8767 23.6233 34.1918 24.6548 34.9773 25.1132C35.2751 25.2865 35.6572 25.187 35.8324 24.8886C36.0063 24.5907 35.9062 24.2086 35.6084 24.0341C35.4686 23.9523 32.1422 22.0333 30.0017 23.2608C28.9104 23.8864 28.3568 25.1522 28.3568 27.0242C28.3568 33.0337 30.1207 34.963 35.6163 34.963C35.9618 34.963 36.2413 34.6835 36.2413 34.338C36.2413 33.9926 35.9618 33.713 35.6163 33.713Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2931 20.8778V31.9142C35.2931 35.2035 37.0207 38.0851 39.616 39.7123C40.3312 40.1607 40.7504 40.9586 40.7504 41.8026V45.5389H48.2496V41.8026C48.2496 40.9586 48.6688 40.1607 49.384 39.7123C51.9793 38.0851 53.7069 35.2035 53.7069 31.9142V20.8778H35.2931Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5431 33.1642V32.2132C36.5431 26.6432 41.0585 22.1278 46.6285 22.1278H53.7069V20.8778H35.2931V31.9142C35.2931 34.7746 36.6004 37.3256 38.6478 39.0126C37.3346 37.4232 36.5431 35.3877 36.5431 33.1642Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6531 17.875H35.3462C34.5171 17.875 33.845 18.5471 33.845 19.3763V19.3769C33.845 20.206 34.5171 20.8781 35.3462 20.8781H53.6531C54.4822 20.8781 55.1543 20.206 55.1543 19.3769V19.3763C55.1543 18.5471 54.4822 17.875 53.6531 17.875Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3466 19.125H53.6533C54.2587 19.125 54.7772 19.4853 55.0147 20.0014C55.1025 19.8106 55.1547 19.6002 55.1547 19.3764C55.1547 18.5472 54.4825 17.875 53.6533 17.875H35.3466C34.5174 17.875 33.8452 18.5472 33.8452 19.3764C33.8452 19.6002 33.8974 19.8106 33.9853 20.0014C34.2228 19.4853 34.7412 19.125 35.3466 19.125Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3547 45.5388H48.6453C50.0251 45.5388 51.1453 46.659 51.1453 48.0388V49.6886H37.8547V48.0388C37.8547 46.659 38.9749 45.5388 40.3547 45.5388Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1047 49.2888C39.1047 47.9081 40.224 46.7888 41.6047 46.7888H49.8954C50.2617 46.7888 50.6071 46.872 50.9206 47.0136C50.5286 46.1455 49.6597 45.5388 48.6454 45.5388H40.3547C38.974 45.5388 37.8547 46.6581 37.8547 48.0388V49.6886H39.1047V49.2888Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7931 49.6886H51.2069C52.5867 49.6886 53.7069 50.8088 53.7069 52.1886V54.125H35.2931V52.1886C35.2931 50.8088 36.4133 49.6886 37.7931 49.6886Z",
    fill: "#C5A34F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5431 53.4386C36.5431 52.0579 37.6624 50.9386 39.0431 50.9386H52.4569C52.8233 50.9386 53.1686 51.0218 53.4822 51.1634C53.0902 50.2953 52.2213 49.6886 51.2069 49.6886H37.7931C36.4124 49.6886 35.2931 50.8079 35.2931 52.1886V54.125H36.5431V53.4386Z",
    fill: "#D3A837"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_92_1396",
    x: 0.5,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.658824 0 0 0 0 0.215686 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_1396"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_1396",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_92_1396",
    x1: 44.5,
    y1: 8,
    x2: 44.5,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE0B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE88"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.622c785902c2721e80ccc44da35bbbc3.svg";
export { ForwardRef as ReactComponent };